import React from 'react'
import CardLayout from '../../components/common/CardLayout'
import { FormattedMessage } from 'react-intl'
import SearchInstructor from '../../components/common/SearchInstructor'

const CdInfo = ({ editable, cdInfo, setFormData, cdinstructorNumber }) => {
  return (
    <CardLayout title={<FormattedMessage id="owsi-cd-info" />} status={cdinstructorNumber}>
      <SearchInstructor
        type={'CD'}
        id={'cd'}
        editable={editable}
        instructor={cdInfo}
        instructorNumber={cdinstructorNumber}
        onSuccess={(result) => {
          setFormData({ cdinstructorNumber: result.instructorNumber })
        }}
      />
    </CardLayout>
  )
}

export default CdInfo
